import {Component, Vue} from 'vue-property-decorator';

import {TweenMax} from '@/utils/gsap';

@Component({})
export default class RippleEffect extends Vue {
	rippleDuration: number = 0.6;

	rippleColor: string = 'rgba(255,255,255,0.3)';

	rippleAwaits: boolean = true;

	async startRipple(event: MouseEvent): Promise<void> {
		const {target: t, offsetX: x, offsetY: y} = event;
		const target = t as HTMLElement;

		if (!target) {
			return;
		}

		const {width, height} = target.getBoundingClientRect();
		const dimension = Math.max(width, height);

		const ripple = document.createElement('div');

		await TweenMax.to(ripple, 0, {
			position: 'absolute',
			background: this.rippleColor,
			borderRadius: '50%',
			top: 0,
			left: 0,
			x: `${x}px`,
			y: `${y}px`,
			width: `1px`,
			height: `1px`,
			transformOrigin: '50% 50%',
			scale: 0,
			alpha: 1
		});

		target.appendChild(ripple);

		if (this.rippleAwaits) {
			await TweenMax.to(ripple, this.rippleDuration, {
				scale: dimension * 2,
				alpha: 0
			});

			target.removeChild(ripple);

			return;
		}

		TweenMax.to(ripple, this.rippleDuration, {
			scale: dimension * 2,
			alpha: 0,
			onComplete() {
				target.removeChild(ripple);
			}
		});
	}
}
